import useNavigateWithPersistedParams from '../../../../js/useNavigateWithPersistedParams';
import { getWorkspacePalette, getProjectColourPalette } from '../../../../js/helper';
import { useParams } from 'react-router-dom';
import { Dropdown, notification, Popover } from 'antd';
import { FormattedMessage, useIntl } from 'react-intl';
import { pinItemToWorkspace } from '../../../../actions/userAction';
import { useDispatch } from 'react-redux';
import { clearMessagesState, updateQueryState } from '../../../../actions/messageAction';
import { setRoomId } from '../../../../actions/roomAction';
import { RESET_COUNTER, UPDATE_CURRENT_RECEIVER } from '../../../../actions/types/chat.types';
import { updateChatRoomMessagesReadBy } from '../../../../actions/chatRoomAction';
import UserAvatar from '../../atoms/ticket-drawer/UserAvatar';

const PinnedRow = ({ allProjects, chats, pinned, isPinnedActive, setIsPinnedActive, index, currentWorkspace }) => {
    const navigateWithPersistedParams = useNavigateWithPersistedParams();
    const dispatch = useDispatch();
    const params = useParams();
    const intl = useIntl();

    let isProject = false;
    let isPortfolio = false;
    let isChat = false

    if (pinned?.entity) {
        isProject = pinned.entity === 'project';
        isPortfolio = pinned.entity === 'portfolio';
        isChat = pinned.entity === 'chat';
    } else {
        if (pinned?.title) {
            isProject = true;
        } else if (pinned?.name && !pinned?.roomType) {
            isPortfolio = true;
        } else if (pinned?.roomType) {
            isChat = true
        }
    }

    const matchedProject = isProject && allProjects?.find(p => p?._id === pinned?._id);
    const pinnedProjects = pinned?.children ?? pinned?.projects ?? [];

    const matchedChat = isChat && chats?.find(c => c?._id === pinned?._id)

    const isDirectChat = matchedChat?.roomType === 'direct';
    const isProjectChat = matchedChat?.roomType === 'project';

    const dmUser = matchedChat?.members?.filter(
        (member) => member?._id !== localStorage.getItem('Id'),
    );
    const chatName =
        isDirectChat && !isProjectChat
            ? dmUser[0]?.fullName || 'User'
            : matchedChat?.roomName;

    const row = (
        <div onClick={() => {
            setIsPinnedActive(true);
            if (isProject) { navigateWithPersistedParams(`/${pinned?._id}/${localStorage.getItem('projectLastView') || 'board'}`) }
            else if (isPortfolio) { navigateWithPersistedParams(`/portfolio/${pinned?._id}`); }
            else {
                if (
                    params?.chatId?.toString() != pinned?._id?.toString()
                ) {
                    dispatch(updateQueryState(1));
                    dispatch(clearMessagesState());
                    dispatch(setRoomId(pinned._id));
                    dispatch({
                        type: RESET_COUNTER,
                        payload: pinned?._id,
                    });
                    navigateWithPersistedParams(`/chat/${pinned?._id}`);
                    dispatch({
                        type: UPDATE_CURRENT_RECEIVER,
                        payload: pinned?.roomName,
                    });
                }
                dispatch(
                    updateChatRoomMessagesReadBy(
                        pinned?._id,
                        'ChatsNavBar1',
                    ),
                );
            }
        }}
            key={pinned?._id + isChat ? 'chat-1' : 'project-1'}
        >
            <Dropdown
                menu={{
                    items: [
                        (isProject || isPortfolio) && {
                            key: pinned?._id + '1',
                            label: (
                                <div className="text-slate-600 font-14 p-2">
                                    <FormattedMessage
                                        id="COPY_LINK"
                                        defaultMessage="Copy Link"
                                    />
                                </div>
                            ),
                            onClick: () => {
                                const url = isProject
                                    ? `${window.location.origin}/${pinned?._id}/board`
                                    : isPortfolio
                                        ? `${window.location.origin}/portfolio/${pinned?._id}`
                                        : window.location.origin;
                                navigator.clipboard.writeText(url);
                                notification.success({
                                    message: intl.formatMessage({
                                        id: 'PROJECT_LINK_COPIED',
                                        defaultMessage: isProject
                                            ? 'Project link copied to clipboard'
                                            : 'Portfolio link copied to clipboard',
                                    }),
                                    placement: 'bottomRight',
                                });
                            }
                        },
                        {
                            key: pinned?._id + '2',
                            label: (
                                <div className="text-slate-600 font-14 p-2">
                                    <FormattedMessage
                                        id="REMOVE_FROM_PINNED"
                                        defaultMessage="Remove from Pinned"
                                    />
                                </div>
                            ),
                            onClick: (e) => {
                                e.domEvent.stopPropagation();
                                let entityType = "project";

                                if (isChat) {
                                    entityType = "chat";
                                } else if (isPortfolio) {
                                    entityType = "portfolio";
                                } else if (isProject) {
                                    entityType = "project";
                                }

                                dispatch(
                                    pinItemToWorkspace(
                                        {
                                            entityId: pinned?._id,
                                            entityType,
                                            workspaceId: currentWorkspace?._id,
                                        },
                                        false,
                                        pinned
                                    )
                                );
                            }
                        },
                    ],
                }}
                trigger={['contextMenu']}
            >
                <div
                    className={`d-flex justify-between cursor-pointer align-center hover:bg-[#394867] w-full ${isPortfolio ? 'py-1' : 'py-2'} ${isChat ? "px-2" : "px-3"} p-2 rounded my-0.5 ${(isPinnedActive && (params?.projectid === pinned._id || params?.portfolioId === pinned._id || params?.chatId === pinned._id))
                        && 'nav-item-active'
                        }`}
                >
                    <div className="flex align-center truncate">
                        {isChat && (isDirectChat ? (
                            <UserAvatar
                                classNames="w-6 h-6 mr-[6px]"
                                fullName={dmUser[0]?.fullName}
                                userId={dmUser[0]?._id}
                                src={dmUser[0]?.avi}
                                styles={{
                                    objectFit: 'cover',
                                    borderRadius: '50%',
                                    border: '2px solid transparent',
                                    aspectRatio: 1,
                                }}
                            />
                        ) : (
                            <img
                                src={matchedChat?.roomAvi}
                                className="w-6 h-6 mr-[6px]"
                                style={{
                                    objectFit: 'cover',
                                    borderRadius: 60,
                                    border: '2px solid #ffffff59',
                                    aspectRatio: 1,
                                }}
                                alt="icon"
                            />
                        ))}
                        {isProject && (() => {
                            const palette = getProjectColourPalette(matchedProject?.metadata?.colour);
                            return <div style={{ background: palette.bg, border: `1px solid ${palette.border}` }} className="w-4 h-4 flex items-center justify-center mr-2 ml-0.5 flex-shrink-0 rounded" />;
                        })()}
                        {isPortfolio && (() => { const p = getWorkspacePalette(pinned?._id || ''); return (
                          <svg width="18" height="16" viewBox="0 0 18 16" className="mr-2 ml-0.5 flex-shrink-0" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <rect x="0.5" y="3.5" width="17" height="12" rx="2.5" fill={p.bg} stroke={p.border}/>
                            <path d="M0.5 6.5H17.5" stroke={p.border} strokeWidth="1"/>
                            <rect x="0.5" y="0.5" width="7" height="4" rx="1.5" fill={p.bg} stroke={p.border}/>
                          </svg>
                        ); })()}
                        <span className="truncate font-14">
                            {pinned?.name || pinned?.title || chatName}
                        </span>
                        {pinned?.archived && (
                            <img
                                src={`/images/icons/archive.svg`}
                                className="h-4 w-4"
                                style={{
                                    margin: '0 10px 0 5px',
                                }}
                                alt="archive"
                            />
                        )}
                    </div>
                    {pinned?.access !== 'public' && !isPortfolio && !isChat && (
                        <img
                            src={`/images/icons/white-lock.svg`}
                            className="h-4 w-4 mr-1"
                            alt="lock"
                        />
                    )}
                    {(pinnedProjects?.length > 0) &&
                        <div
                            className={`flex items-center justify-center size-7 cursor-pointer rounded py-1 ml-1 px-0.5 ${isPinnedActive && (params?.projectid === pinned._id || params?.portfolioId === pinned._id)
                                ? "hover:bg-[rgba(0,0,0,0.1)]"
                                : "hover:bg-slate-600"
                                }`}
                        >
                            <img
                                src={`/images/icons/arrow-forward.svg`}
                                alt="arrow"
                                className="transition-transform duration-300 cursor-pointer h-4 w-4"
                                style={{
                                    filter: 'invert(1) brightness(500%)',
                                }}
                            />
                        </div>}
                </div>
            </Dropdown>
        </div>
    )

    return (
        <div key={pinned?._id + 'container'}>
            {(pinnedProjects?.length > 0) ? (
                <Popover
                    trigger="hover"
                    placement="rightTop"
                    arrow={false}
                    content={
                        <div className="w-72 py-1.5">
                            <p className="text-[11px] font-semibold uppercase tracking-wider text-slate-400 px-3 pb-1.5 pt-0.5">
                                <FormattedMessage id='PORTFOLIO_PROJECTS' defaultMessage='Portfolio Projects' />
                            </p>
                            <div className="overflow-y-auto max-h-[25vh]">
                                {pinnedProjects?.filter(child => child).map(child => {
                                    const matchedProject = allProjects?.find(p => p?._id === child?._id);
                                    const palette = getProjectColourPalette(matchedProject?.metadata?.colour || child?.metadata?.colour);
                                    const access = matchedProject?.access || child?.access;
                                    return (
                                        <div
                                            key={child._id}
                                            className="flex items-center gap-3 px-3 py-2 cursor-pointer transition-colors"
                                            style={{ background: 'transparent' }}
                                            onMouseEnter={e => e.currentTarget.style.background = 'rgba(99,102,241,0.04)'}
                                            onMouseLeave={e => e.currentTarget.style.background = 'transparent'}
                                            onClick={(e) => { e.stopPropagation(); navigateWithPersistedParams(`/${child?._id}/${localStorage.getItem('projectLastView') || 'board'}`) }}
                                        >
                                            <div className="h-8 w-8 flex-shrink-0 flex items-center justify-center rounded-lg" style={{ background: palette.bg, border: `1px solid ${palette.border}` }}>
                                                <img src="/images/icons/board.svg" className="w-4 h-4" style={{ filter: 'brightness(0) saturate(100%)', opacity: 0.45 }} alt="" />
                                            </div>
                                            <div className="min-w-0">
                                                <div className="text-[13px] font-medium truncate" style={{ color: 'rgba(15,15,25,0.82)' }}>{child?.title}</div>
                                                <span
                                                    className="text-[10px] px-1.5 py-0.5 rounded capitalize font-medium"
                                                    style={access === 'public'
                                                        ? { background: 'rgba(16,185,129,0.1)', color: '#059669' }
                                                        : { background: 'rgba(99,102,241,0.08)', color: 'rgba(99,102,241,0.7)' }}
                                                >
                                                    {access || 'public'}
                                                </span>
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                    }
                >
                    {row}
                </Popover>
            ) : (
                <>
                    {row}
                </>
            )}
        </div>
    )
}

export default PinnedRow
